import { apiRequest } from '@/api/core/auth';
import { CacheManager } from '@/utils/core/cacheManager.js';

// What the legacy portal (home.js) and login (login.js) pages loaded when a session opened, now called by
// the Vue session (src/utils/auth/sessionService.js). Each call takes the token it needs explicitly: the
// session is being built, nothing can be read from it yet. Offline, the session comes back from the legacy
// storage (app/vueSession.js restore), not from here.

// login.js start(): the customer (alias, logo).
export const getCurrentCustomer = (token) => apiRequest('GET', 'Core/Customers/Current', { token });

// home.js / login.js launchApp(): refreshes ctx.user.processTypes.
export const getUsersInfo = (token, userId) => apiRequest('GET', `Core/UsersInfo/${userId}`, { token });

// home.js getApps(): the applications of the user (base token).
export const getApplications = (token) => apiRequest('GET', 'Core/Applications', { token });

// salesHelper.checkWebAppActive() with the base token, home.js __successSales() with the SALFO token.
export const getOptions = (token) => apiRequest('GET', 'Core/Options', { token });

// home.js __successAssort(): the Assort menus of the ASSFO token; none means no access to Assort.
export const getApplicationMenus = (token) => apiRequest('GET', 'Core/Menus', { token });

// The roles of the customer, for the role of the user in the portal greeting (base token, like src/api/core/role.js).
export const getRoles = (token) => apiRequest('GET', 'Core/Roles', { token });

async function fetchStatic(path) {
	const response = await fetch(`${path}?foo=${Date.now()}`);
	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
	return response.json();
}

// home.js loadSLSetting(): ag-Grid license, Helpjuice secret, AppInsights / BugHospital customers.
export const getSlSettings = () => fetchStatic('/m.eagle/sl.json');

let newsCache = null;
const getNewsCache = () => (newsCache ??= new CacheManager('VueCache', 'cache', { maxAge: 30 * 24 * 60 * 60 * 1000, memoryCacheTTL: 60 * 60 * 1000, logCategory: 'Portal' }));

// home.js loadNews(): the portal news, the same for every customer.
export const getNews = () => getNewsCache().fetchOrCache('portal.news', () => fetchStatic('/m.eagle/news.json'), { fallback: [], backgroundRefresh: true });
